// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#Account {
  width: 100%;
  --primary-color-disabled: #707070;
  --primary-color-light: #434343;
  --primary-color-main: #222222;
  --primary-color-dark: #0f0f0f;
  /* モバイル */
  /* タブレット */
  /* PC */
}
@media (width < 752px) {
  #Account {
    --login-min-width: 100vw;
    --login-min-height: 100vh;
  }
}
@media (752px <= width < 1122px) {
  #Account {
    --login-min-width: 100vw;
    --login-min-height: 100vh;
  }
}
@media (1122px <= width) {
  #Account {
    --login-min-width: 420px;
    --login-min-height: 520px;
  }
}
#Account .title-text {
  font-family: "Inter";
  font-size: 72px;
  letter-spacing: 24px;
  font-weight: 400;
}
#Account .title-text span {
  font-weight: 200;
}
#Account .paper-login {
  width: 100%;
  height: var(--login-min-height);
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
#Account .logo {
  width: 289.85px;
  height: auto;
}
#Account .divide-half-area {
  padding: 32px;
}
#Account .divide-half-area.input-area {
  width: 50vw;
  min-width: 400px;
  background-color: var(--white-color-lightest);
}
#Account .divide-half-area.info-area {
  width: 50vw;
  padding: 0;
  background-color: var(--white-color-lightest);
  position: relative;
}
#Account .divide-half-area.info-area .video {
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
}
#Account .divide-half-area.info-area .top-visual-area {
  overflow: hidden;
  width: fit-content;
}
#Account .divide-half-area.info-area .top-visual {
  height: 100%;
  width: auto;
  object-fit: cover;
}
#Account .info-text {
  color: var(--font_active_hidden_color);
  letter-spacing: 1px;
  font-family: "Inter";
  font-weight: 400;
}
#Account .copy-text {
  font-size: clamp(16px, 2vw, 48px);
  color: var(--white-color-lightest);
  font-weight: 600;
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  z-index: var(--z-index-local-over-2);
}
@keyframes GradientBackground {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
#AccountTop {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/account/parts/AccountTop.scss","webpack://./src/components/account/Account.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACI,WAAA;EAEA,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,SAAA;EAMA,UAAA;EAMA,OAAA;ADVJ;ACDI;EATJ;IAUQ,wBAAA;IACA,yBAAA;EDIN;AACF;ACDI;EAfJ;IAgBQ,wBAAA;IACA,yBAAA;EDIN;AACF;ACDI;EArBJ;IAsBQ,wBAAA;IACA,yBAAA;EDIN;AACF;ACFI;EACI,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;ADIR;ACFQ;EACI,gBAAA;ADIZ;ACAI;EACI,WAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;ADER;ACCI;EAEI,eAAA;EACA,YAAA;ADAR;ACGI;EACI,aAAA;ADDR;ACEQ;EACI,WAAA;EACA,gBAAA;EACA,6CAAA;ADAZ;ACEQ;EACI,WAAA;EACA,UAAA;EAEA,6CAAA;EAEA,kBAAA;ADFZ;ACoBY;EACI,kBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;ADlBhB;ACqBY;EACI,gBAAA;EACA,kBAAA;ADnBhB;ACsBY;EACI,YAAA;EACA,WAAA;EACA,iBAAA;ADpBhB;ACyBI;EACI,sCAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ADvBR;AC0BI;EACI,iCAAA;EACA,kCAAA;EACA,gBAAA;EAEA,uCAAA;EACA,oCAAA;ADzBR;ACiCA;EACI;IACI,2BAAA;ED/BN;ECkCE;IACI,6BAAA;EDhCN;ECmCE;IACI,2BAAA;EDjCN;AACF;AApGA;EAEI,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;AAqGJ","sourcesContent":["@import '../Account.scss';\r\n\r\n#AccountTop\r\n{\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    justify-content: center;\r\n}","#Account {\r\n    width: 100%;\r\n\r\n    --primary-color-disabled:  #707070;\r\n    --primary-color-light:  #434343;\r\n    --primary-color-main:   #222222;\r\n    --primary-color-dark:   #0f0f0f;\r\n\r\n    /* モバイル */\r\n    @media (width < 752px) {\r\n        --login-min-width: 100vw;\r\n        --login-min-height: 100vh;\r\n    }\r\n    \r\n    /* タブレット */\r\n    @media (752px <= width < 1122px) {\r\n        --login-min-width: 100vw;\r\n        --login-min-height: 100vh;\r\n    }\r\n    \r\n    /* PC */\r\n    @media (1122px <= width) {\r\n        --login-min-width: 420px;\r\n        --login-min-height: 520px;\r\n    }\r\n    \r\n    .title-text{\r\n        font-family: \"Inter\";\r\n        font-size: 72px;\r\n        letter-spacing: 24px;\r\n        font-weight: 400;\r\n\r\n        span{\r\n            font-weight: 200;\r\n        }\r\n    }\r\n\r\n    .paper-login {\r\n        width: 100%;\r\n        height: var(--login-min-height);\r\n        padding: 32px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n    }\r\n\r\n    .logo\r\n    {\r\n        width: calc(527px * 0.55);\r\n        height: auto;\r\n    }\r\n\r\n    .divide-half-area{\r\n        padding: 32px;\r\n        &.input-area{\r\n            width: 50vw;\r\n            min-width: 400px;\r\n            background-color: var(--white-color-lightest);\r\n        }\r\n        &.info-area{\r\n            width: 50vw;\r\n            padding: 0;\r\n            // background: var(--main-gradation);\r\n            background-color: var(--white-color-lightest);\r\n\r\n            position: relative;\r\n\r\n            // &::after{\r\n            //     content: \"\";\r\n            //     position: absolute;\r\n            //     height: 100%;\r\n            //     width: 100%;\r\n            //     top: 0;\r\n            //     left: 0;\r\n            //     bottom: 0;\r\n            //     right: 0;\r\n            //     background: linear-gradient(45deg, #F684AA, #D1B6F4, #6395eb);\r\n            //     opacity: 0.7;\r\n            //     background-size: 600% 600%;\r\n            //     animation: GradientBackground 10s ease infinite;\r\n            //     z-index: var(--z-index-local-over-1);\r\n            // }\r\n\r\n            .video{\r\n                position: absolute;\r\n                height: 100%;\r\n                top: 0;\r\n                left: 0;\r\n            }\r\n\r\n            .top-visual-area{\r\n                overflow: hidden;\r\n                width: fit-content;\r\n            }\r\n\r\n            .top-visual{\r\n                height: 100%;\r\n                width: auto;\r\n                object-fit: cover;\r\n            }\r\n        }\r\n    }\r\n\r\n    .info-text{\r\n        color: var(--font_active_hidden_color);\r\n        letter-spacing: 1px;\r\n        font-family: \"Inter\";\r\n        font-weight: 400;\r\n    }\r\n\r\n    .copy-text {\r\n        font-size: clamp(16px, 2vw, 48px);\r\n        color: var(--white-color-lightest);\r\n        font-weight: 600;\r\n\r\n        text-shadow: 0 0 8px rgba(0, 0, 0, .3);\r\n        z-index: var(--z-index-local-over-2);\r\n    }\r\n    .input-card{\r\n\r\n    }\r\n}\r\n\r\n\r\n@keyframes GradientBackground {\r\n    0% {\r\n        background-position: 0% 50%;\r\n    }\r\n\r\n    50% {\r\n        background-position: 100% 50%;\r\n    }\r\n\r\n    100% {\r\n        background-position: 0% 50%;\r\n    }\r\n};\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
